import type { IDexPair } from 'types/pairs';

const SOL_MINT = 'So11111111111111111111111111111111111111112';

// Legacy Solana pairs use SOL when quote metadata is absent or blank.
// Keep explicit non-SOL quote metadata intact.
export function normalizeSolPair(pair: IDexPair): IDexPair {
  const quoteAddress = pair.token_quote.address?.trim() || SOL_MINT;
  const solQuote = quoteAddress === SOL_MINT;
  return {
    ...pair,
    token_fee: { ...pair.token_fee, address: SOL_MINT, symbol: 'SOL', decimals: 9 },
    token_quote: {
      ...pair.token_quote,
      address: quoteAddress,
      symbol: pair.token_quote.symbol?.trim() || (solQuote ? 'SOL' : ''),
      decimals: solQuote ? 9 : pair.token_quote.decimals,
    },
  };
}
